let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9iSQB")).then(() => parcelRequire('c3n3p'));